import { error, finish } from '../../../modules/liabilities/actions/last-legs-rum';
import api from '../../../api';

export function request(dispatch) {
    api.get('/liabilities-alerts/last-leg-rum', void 0).then(
        result => dispatch(finish( result ? result.selections : [])),
        errors => dispatch(error(errors))
    );
}
